// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__20iWv","button":"button__25Q3x","amount":"amount__3mKNQ"};